import type { ReactNode } from 'react';
import { highlightFlux } from './highlight';

interface CodeBlockProps {
  /** Filename or task name shown in the header. */
  title: string;
  code: string;
  /** Rendered to the right of the title, e.g. copy and download buttons. */
  actions?: ReactNode;
  /** Accessible description of what this script does. */
  description?: string;
}

export default function CodeBlock({ title, code, actions, description }: CodeBlockProps) {
  const labelId = `code-${title.replace(/[^a-z0-9]+/gi, '-')}`;
  return (
    <section className="panel" aria-labelledby={labelId}>
      <div className="code-head">
        <span className="code-title" id={labelId}>
          {title}
        </span>
        <span className="tier-actions">{actions}</span>
      </div>
      {description ? (
        <p className="visually-hidden" id={`${labelId}-desc`}>
          {description}
        </p>
      ) : null}
      <pre
        className="code"
        tabIndex={0}
        role="region"
        aria-labelledby={labelId}
        aria-describedby={description ? `${labelId}-desc` : undefined}
      >
        <code>{highlightFlux(code)}</code>
      </pre>
    </section>
  );
}
